import { Pipe, PipeTransform } from '@angular/core';

import dayjs, { Duration } from '../../core/configs/dayjs';

@Pipe({
	name: 'toDayjsDuration',
})
export class ToDayjsDurationPipe implements PipeTransform {
	public transform(value: number | null | undefined): Duration {
		if (value === null || value === undefined) {
			return dayjs.duration(0);
		}
		if (isNaN(value)) {
			return dayjs.duration(0);
		}
		return dayjs.duration(value);
	}
}
